export const isDropzone = (left: number, top: number, id: string) => {
    const rect = document?.getElementById(id)?.getBoundingClientRect();

    if (!rect) {
        return false;
    }

    return rect.left <= left && left <= rect.right && rect.top <= top && top <= rect.bottom;
};
